export default __webpack_public_path__ + "static/media/laglerLarge.ed1dd471.jpg";